import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-pricing'
})
export class Ng1PricingDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('pricing', elementRef, injector);
  }
}
